import { AxiosResponse } from 'axios'
import Request from 'redux/config/services/Request'
import { ReportParams } from './types'

const getOverallReport = (params: ReportParams): Promise<AxiosResponse> => {
  let URLQuery = ''

  if (params.startDate) {
    URLQuery = 'start_date=' + params.startDate
  }
  if (params.endDate) {
    URLQuery += '&end_date=' + params.endDate
  }
  if (params.segments) {
    params.segments.forEach((segment) => {
      URLQuery += '&segments=' + segment
    })
  }

  if (params.reportGettingType === 'json') {
    URLQuery += '&format=json'
  }

  // Currently the report is coming in html format from the backend
  if (params.reportGettingType === 'csv') {
    URLQuery += '&format=html'
  }

  return Request.get('/hr/reporting/report/?' + URLQuery, true)
}

const getRemainingReports = (params: ReportParams): Promise<AxiosResponse> => {
  const reportUrls = {
    otr: '/hr/reporting/reports/one_time_rewards/',
    competitions: '/hr/reporting/reports/competition_winners/',
    trips: '/hr/reporting/reports/trips/',
    incentives: '/hr/reporting/reports/incentives_rewarded/',
    transactions: '/hr/reporting/reports/transactions/',
    taxSavings: '/hr/reporting/reports/pretax_eligible_transactions/',
    programAllocation: '/hr/reporting/reports/program_allocation/',
    reimbursements: '/hr/reporting/reports/reimbursements/',
  }

  let URLQuery = ''
  if (params.startDate) {
    URLQuery = 'date__gte=' + params.startDate
  }
  if (params.endDate) {
    URLQuery += '&date__lt=' + params.endDate
  }
  if (params.segments) {
    params.segments.forEach((segment) => {
      URLQuery += '&segments=' + segment
    })
  }

  if (params.reportGettingType === 'json') {
    URLQuery += '&format=json'
  }

  if (params.reportGettingType === 'csv') {
    URLQuery += '&format=csv'
  }

  return Request.get(`${reportUrls[params.reportType]}?${URLQuery}`, true)
}

const generateAiReport = (prompt: string): Promise<AxiosResponse> => {
  return Request.post('/hr/reporting/ai_report/', { prompt }, undefined, true)
}

const getAiReportJob = (jobId: string): Promise<AxiosResponse> => {
  return Request.get(`/hr/reporting/ai_report/${jobId}/`, true)
}

export const AI_REPORT_POLL_INTERVAL_MS = 5000
export const AI_REPORT_POLL_MAX_ATTEMPTS = 24

export const reportsService = {
  getOverallReport,
  getRemainingReports,
  generateAiReport,
  getAiReportJob,
}

export default reportsService
